// ************************************************************************************************
// pathname: /v1/resume/interview-video/{id}
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi';

interface UseSwrResumeInterviewVideoDeleteProps {
  videoId: string;
  locale: string;
  successCallback?: (videoId: string) => void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: Delete AI Interview Video
 * @param videoId - string. The ID of the video to delete.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param errorCallback - function. The callback to call on error.
 */
export const useSwrResumeInterviewVideoDelete = (
  props: UseSwrResumeInterviewVideoDeleteProps,
) => {
  const {
    videoId, locale = 'ro', successCallback, errorCallback,
  } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, never>({
    url: `/v1/resume/interview-video/${videoId}`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => successCallback?.(videoId),
      onError: () => errorCallback?.(),
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
